module.exports = __webpack_public_path__ + "img/53.5273756b.jpg";